import { BaseComponentDrawer } from '../../../core/abstraction/BaseComponentDrawer';

export class BaseBonusPadDrawer extends BaseComponentDrawer {

}
